import '../css/UI.css';
import type { AppState, Data, DataItem } from '../types';
import { appState } from './AppState';
import { CATEGORY_ICONS, PROFILE_CLOSE_BTN, PROGRAMME_TRANSLATIONS } from './UI.details';

import 'overlayscrollbars/overlayscrollbars.css';
import { OverlayScrollbars } from 'overlayscrollbars';
import isMobile from 'is-mobile';

export default class UI {
	hasInited: boolean;
	profiles: HTMLElement[];
	profilesWrapper: HTMLElement | null;
	categories: string[];
	programmes: string[];
	profileScrollbar: any | null;
	profilesIcon: HTMLElement | null;
	resetBtn: HTMLElement | null;
	swipeState = {
		active: false,
		swiping: false,
		pointerId: null as number | null,
		startX: 0,
		startY: 0,
		lastX: 0,
		startTime: 0
	};
	isMobile: boolean;
	bodyScroll!: OverlayScrollbars | null;

	constructor() {
		this.hasInited = false;
		this.profiles = [];
		this.categories = [];
		this.programmes = [];
		this.profileScrollbar = null;
		this.profilesWrapper = document.getElementById('profiles');
		this.profilesIcon = document.getElementById('profiles-icon');
		this.resetBtn = document.getElementById('reset-filters-btn');
		this.isMobile = isMobile();
		this.bodyScroll = null;
	}

	init() {
		appState.subscribe(this.onStateChange.bind(this));

		console.log('UI init');
	}

	onStateChange(state: AppState): void {
		if (!this.hasInited) {
			this.makeUI(state.data);
			this.hasInited = true;
		}
		this.onFilter(state.categoryIndex, state.programmeIndex);
		this.onLangChange(state.lang);

		if (this.isMobile) {
			this.updateReset(state.categoryIndex, state.programmeIndex);
		}
	}

	makeUI(data: Data): void {
		if (this.isMobile) {
			document.body.classList.add('is-mobile');
		} else {
			document.body.classList.remove('is-mobile');
		}

		this.setupLanding();
		this.setupEnterArrow();
		this.setupHeaderScroll();
		this.setupMenu();
		this.setupMenuOptions();
		this.setupLangSwitcher();
		this.setupResetFilter();
		this.setupIcon();
		this.makeCategoryFilters(data);
		this.makeProgrammeFilters(data);
		this.makeProfiles(data);
		// this.setupSwipe();
		this.disablePageZoom();
	}

	private scrollToY(y: number, behavior: ScrollBehavior = 'smooth'): void {
		const inst = this.bodyScroll;

		if (inst) {
			const els = inst.elements();
			const scrollEl: any = els.scrollOffsetElement || els.viewport;

			if (scrollEl) {
				if (typeof scrollEl.scrollTo === 'function') {
					scrollEl.scrollTo({ top: y, left: 0, behavior });
				} else if ('scrollTop' in scrollEl) {
					scrollEl.scrollTop = y;
				}
				return;
			}
		}

		// Fallback to native window scroll
		window.scrollTo({ left: 0, top: y, behavior });
	}

	disablePageZoom() {
		// Block two-finger pinch and “scale” changes
		window.addEventListener(
			'touchstart',
			(e) => {
				if (e.touches.length > 1) e.preventDefault();
			},
			{ passive: false }
		);

		window.addEventListener(
			'touchmove',
			(e: any) => {
				if (e.touches?.length > 1 || (typeof e.scale === 'number' && e.scale !== 1)) {
					e.preventDefault();
				}
			},
			{ passive: false }
		);

		// Block double-tap zoom
		let lastTouchEnd = 0;
		window.addEventListener(
			'touchend',
			(e) => {
				const now = Date.now();
				if (now - lastTouchEnd <= 300) e.preventDefault();
				lastTouchEnd = now;
			},
			{ passive: false }
		);

		// Extra: older Safari gesture events
		const block = (ev: Event) => ev.preventDefault();
		window.addEventListener('gesturestart', block);
		window.addEventListener('gesturechange', block);
		window.addEventListener('gestureend', block);
	}

	// setupSwipe(): void {
	// 	const el = this.profilesWrapper;
	// 	if (!el) return;

	// 	const onPointerDown = (e: PointerEvent) => {
	// 		if (!e.isPrimary) return;
	// 		if (e.pointerType === 'mouse' && e.button !== 0) return; // only left button
	// 		if (this.isSwipeBlockedTarget(e.target)) return;

	// 		this.swipeState.pointerId = e.pointerId;
	// 		this.swipeState.active = true;
	// 		this.swipeState.swiping = false;
	// 		this.swipeState.startX = e.clientX;
	// 		this.swipeState.startY = e.clientY;
	// 		this.swipeState.lastX = e.clientX;
	// 		this.swipeState.startTime = e.timeStamp;
	// 		(el as HTMLElement).setPointerCapture(e.pointerId);
	// 	};

	// 	const onPointerMove = (e: PointerEvent) => {
	// 		if (!this.swipeState.active || e.pointerId !== this.swipeState.pointerId) return;
	// 		const dx = e.clientX - this.swipeState.startX;
	// 		const dy = e.clientY - this.swipeState.startY;

	// 		if (!this.swipeState.swiping) {
	// 			if (Math.abs(dx) > 10 && Math.abs(dy) <= Math.abs(dx) * OFF_AXIS_RATIO) {
	// 				this.swipeState.swiping = true;
	// 			} else {
	// 				return; // allow normal vertical scroll
	// 			}
	// 		}

	// 		// now in horizontal swipe
	// 		e.preventDefault();
	// 		this.swipeState.lastX = e.clientX;
	// 	};

	// 	const onPointerEnd = (e: PointerEvent) => {
	// 		if (!this.swipeState.active || e.pointerId !== this.swipeState.pointerId) return;

	// 		const dx = e.clientX - this.swipeState.startX;
	// 		const dt = e.timeStamp - this.swipeState.startTime;
	// 		const absDx = Math.abs(dx);
	// 		const direction = dx < 0 ? 'left' : 'right';
	// 		const velocityX = dt > 0 ? dx / dt : 0;

	// 		(el as HTMLElement).releasePointerCapture(e.pointerId);

	// 		this.swipeState.active = false;
	// 		this.swipeState.swiping = false;
	// 		this.swipeState.pointerId = null;

	// 		if (absDx >= SWIPE_THRESHOLD_PX) {
	// 			const detail = { direction, deltaX: dx, velocityX };
	// 			el.dispatchEvent(new CustomEvent('profiles:swipe', { detail }));
	// 			el.dispatchEvent(new CustomEvent(`profiles:swipe${direction}`, { detail }));
	// 		}
	// 	};

	// 	el.addEventListener('pointerdown', onPointerDown, { passive: true });
	// 	el.addEventListener('pointermove', onPointerMove); // not passive
	// 	el.addEventListener('pointerup', onPointerEnd);
	// 	el.addEventListener('pointercancel', onPointerEnd);
	// 	el.addEventListener('pointerleave', onPointerEnd);

	// 	this.profilesWrapper?.addEventListener('profiles:swipeleft', () => {
	// 		this.stepProfile('next');
	// 	});

	// 	this.profilesWrapper?.addEventListener('profiles:swiperight', () => {
	// 		this.stepProfile('prev');
	// 	});
	// }

	stepProfile(direction: 'next' | 'prev') {
		const currentState = appState.getState();
		const currentCategoryIndex = currentState.categoryIndex || 0;
		const currentProgrammeIndex = currentState.programmeIndex || 0;
		let nextProgrammeIndex = direction === 'next' ? currentProgrammeIndex + 1 : currentProgrammeIndex - 1;
		let nextCategoryIndex = currentCategoryIndex;
		if (nextProgrammeIndex < 0) {
			nextProgrammeIndex = this.programmes.length - 1;
			nextCategoryIndex = currentCategoryIndex - 1;
			nextCategoryIndex = nextCategoryIndex < 0 ? this.categories.length - 1 : nextCategoryIndex;
		}
		if (nextProgrammeIndex >= this.programmes.length) {
			nextProgrammeIndex = 0;
			nextCategoryIndex = currentCategoryIndex + 1;
			nextCategoryIndex = nextCategoryIndex >= this.categories.length ? 0 : nextCategoryIndex;
		}
		appState.setState({ categoryIndex: nextCategoryIndex, programmeIndex: nextProgrammeIndex });
	}

	isSwipeBlockedTarget(t: EventTarget | null): boolean {
		const el = t as Element | null;
		if (
			el?.closest(
				'button, a[href], input, textarea, select, label, [contenteditable="true"], [role="button"], [role="link"], .profile-close-btn'
			) ||
			el?.closest('.dropdown, ul.dropdown-list, li.dropdown-option') ||
			el?.closest('#profiles-header')
		) {
			return true;
		}

		return false;
	}

	setupLanding(): void {
		const v = document.getElementById('landing') as HTMLVideoElement;
		if (v) {
			v.controls = false;
		}
	}

	setupEnterArrow(): void {
		const arrow = document.getElementById('enter-arrow');
		if (!arrow) return;

		arrow.onclick = () => {
			setTimeout(() => {
				const filters = document.getElementById('profiles');
				const y = filters?.offsetTop || 0;
				this.scrollToY(y, 'smooth');
			});
		};
	}

	setupHeaderScroll(): void {
		const headerBg = document.querySelector('#header-bg');

		const os = OverlayScrollbars(document.body, {
			overflow: { x: 'hidden', y: 'scroll' }
		});
		this.bodyScroll = os;

		const updateHeader = () => {
			const els = os.elements();
			const scrollEl: any = els.scrollOffsetElement || els.viewport;
			const y = scrollEl ? scrollEl.scrollTop || 0 : 0;

			if (y > 0) {
				headerBg?.classList.add('scrolled');
			} else {
				headerBg?.classList.remove('scrolled');
			}
		};

		updateHeader();
		os.on('scroll', updateHeader);
	}

	setupMenu(): void {
		const container = document.getElementById('app');
		const menuOpenBtn = document.getElementById('menu-open-btn');
		const menuCloseBtn = document.getElementById('menu-close-btn');
		const menu = document.getElementById('menu');
		const overlay = document.getElementById('overlay');
		if (!container || !menuOpenBtn || !menuCloseBtn || !menu || !overlay) return;

		menuOpenBtn.onclick = () => {
			this.scrollToY(0, 'smooth');
			container.classList.add('menu');
			menu.classList.add('show');
		};

		menuCloseBtn.onclick = () => {
			this.scrollToY(0, 'smooth');
			container.classList.remove('menu');
			container.classList.remove('overlay');
			menu.classList.remove('show');
			overlay.classList.remove('show');
		};
	}

	setupMenuOptions(): void {
		const container = document.getElementById('app');
		const menu = document.getElementById('menu');
		const overlay = document.getElementById('overlay');
		const menuOptionMatrix = document.getElementById('menu-option-matrix');
		const menuOptionInstallation = document.getElementById('menu-option-installation');
		if (!container || !menu || !overlay || !menuOptionMatrix || !menuOptionInstallation) return;

		menuOptionMatrix.onclick = () => {
			container.classList.remove('menu');
			menu.classList.remove('show');
			setTimeout(() => {
				const filters = document.getElementById('profiles');
				const y = filters?.offsetTop || 0;
				this.scrollToY(y, 'smooth');
			});
		};

		menuOptionInstallation.onclick = () => {
			this.scrollToY(0, 'smooth');
			container.classList.remove('menu');
			container.classList.add('overlay');
			menu.classList.remove('show');
			overlay.classList.add('show');
		};
	}

	setupLangSwitcher(): void {
		const switcher = document.getElementById('lang-switcher');
		if (!switcher) return;
		switcher.onclick = () => {
			const currentState = appState.getState();
			const newLang = currentState.lang === 'hu' ? 'en' : 'hu';
			appState.setState({ ...currentState, lang: newLang });
		};
	}

	setupResetFilter(): void {
		if (!this.resetBtn) return;
		this.resetBtn.onclick = () => {
			const currentState = appState.getState();
			currentState.categoryIndex = null;
			currentState.programmeIndex = null;
			appState.setState({ ...currentState });
		};
		if (!this.isMobile) this.resetBtn.classList.add('hidden');
	}

	makeCategoryFilters(data: Data): void {
		for (const element of Object.values(data)) {
			if (element.theme && !this.categories.includes(element.theme)) {
				this.categories.push(element.theme);
			}
		}

		const categoriesWrapper = document.getElementById('category-filters-wrapper');
		if (categoriesWrapper && !this.isMobile) {
			const fragment = new DocumentFragment();
			let index = 0;
			for (const category of this.categories) {
				const button = this.getCategoryFilter(category, index);
				fragment.appendChild(button);
				index++;
			}
			categoriesWrapper.appendChild(fragment);
		}

		if (this.isMobile) {
			const list = document.getElementById('category-dropdown-list');
			const btn = document.getElementById('category-dropdown-btn');

			if (list) {
				const fragment = new DocumentFragment();
				let index = 0;
				for (const category of this.categories) {
					const option = this.getCategoryDropdownOption(category, index);
					fragment.appendChild(option);
					index++;
				}
				list.appendChild(fragment);
			}

			if (btn && list) {
				btn.addEventListener('click', () => {
					const programmeBtn = document.getElementById('programme-dropdown-btn');
					const programmeList = document.getElementById('programme-dropdown-list');
					const open = btn.getAttribute('aria-expanded') === 'true';

					btn.setAttribute('aria-expanded', String(!open));
					open ? list.classList.remove('active') : list.classList.add('active');

					programmeBtn?.setAttribute('aria-expanded', 'false');
					programmeList?.classList.remove('active');
				});
			}
		}
	}

	getCategoryDropdownOption(value: string, index: number): HTMLElement {
		const option = document.createElement('li');
		option.classList.add('dropdown-option', 'category-dropdown-option');
		option.dataset.index = index.toString();

		const svg = CATEGORY_ICONS[value];
		if (svg) option.innerHTML = svg;

		const span = document.createElement('span');
		span.textContent = value;
		option.appendChild(span);

		option.onclick = () => {
			this.onFilterClicked('category', index);
		};

		return option;
	}

	makeProgrammeFilters(data: Data): void {
		for (const element of Object.values(data)) {
			if (element.programme && !this.programmes.includes(element.programme)) {
				this.programmes.push(element.programme);
			}
		}

		const programmesWrapper = document.getElementById('programme-filters-wrapper');
		if (programmesWrapper && !this.isMobile) {
			const fragment = new DocumentFragment();
			let index = 0;
			for (const programme of this.programmes) {
				const button = this.getProgrammeFilter(programme, index);
				fragment.appendChild(button);
				index++;
			}
			programmesWrapper.appendChild(fragment);
		}

		if (this.isMobile) {
			const list = document.getElementById('programme-dropdown-list');
			const btn = document.getElementById('programme-dropdown-btn');

			if (list) {
				const fragment = new DocumentFragment();
				let index = 0;
				for (const programme of this.programmes) {
					const option = this.getProgrammeDropdownOption(programme, index);
					fragment.appendChild(option);
					index++;
				}
				list.appendChild(fragment);
			}

			if (btn && list) {
				btn.addEventListener('click', () => {
					const categoryList = document.getElementById('category-dropdown-list');
					const categoryBtn = document.getElementById('category-dropdown-btn');
					const open = btn.getAttribute('aria-expanded') === 'true';

					btn.setAttribute('aria-expanded', String(!open));
					open ? list.classList.remove('active') : list.classList.add('active');

					categoryBtn?.setAttribute('aria-expanded', 'false');
					categoryList?.classList.remove('active');
				});
			}
		}
	}

	getProgrammeDropdownOption(value: string, index: number): HTMLElement {
		const option = document.createElement('li');
		option.classList.add('dropdown-option', 'programme-dropdown-option');
		option.dataset.index = index.toString();

		const programmeName = value.replace(' MA', '');
		const translation = PROGRAMME_TRANSLATIONS[programmeName] || programmeName;

		const spanHu = document.createElement('span');
		spanHu.classList.add('hu');
		spanHu.textContent = translation;

		const spanEn = document.createElement('span');
		spanEn.classList.add('en');
		spanEn.textContent = programmeName;

		option.appendChild(spanHu);
		option.appendChild(spanEn);

		option.onclick = () => {
			this.onFilterClicked('programme', index);
		};

		return option;
	}

	getCategoryFilter(value: string, index: number): HTMLElement {
		const filter = document.createElement('div');
		filter.classList.add('filter');
		filter.classList.add(`category-filter`);
		filter.dataset.index = index.toString();

		const svg = CATEGORY_ICONS[value];
		if (svg) filter.innerHTML = svg;
		const span = document.createElement('span');
		// span.dataset.text = value;

		span.innerHTML = value;
		filter.appendChild(span);
		filter.onclick = () => {
			this.onFilterClicked('category', index);
		};
		return filter;
	}

	getProgrammeFilter(value: string, index: number): HTMLElement {
		const filter = document.createElement('div');
		filter.classList.add('filter');
		filter.classList.add(`programme-filter`);
		filter.dataset.index = index.toString();
		// filter.dataset.text = value;
		const programmeName = value.replace(' MA', '');
		const programmeTranslation = PROGRAMME_TRANSLATIONS[programmeName];
		const spanHu = document.createElement('span');
		const spanEn = document.createElement('span');
		spanHu.classList.add('hu');
		spanHu.innerHTML = programmeTranslation || programmeName || 'N/A';
		spanEn.classList.add('en');
		spanEn.innerHTML = programmeName || 'N/A';
		filter.appendChild(spanHu);
		filter.appendChild(spanEn);
		filter.onclick = () => {
			this.onFilterClicked('programme', index);
		};
		return filter;
	}

	onFilterClicked(type: string, index: number): void {
		const currentState = appState.getState();
		if (type === 'category') {
			const categoryIndex = currentState.categoryIndex === index ? null : index;
			appState.setState({ ...currentState, categoryIndex });
		} else if (type === 'programme') {
			const programmeIndex = currentState.programmeIndex === index ? null : index;
			appState.setState({ ...currentState, programmeIndex });
		}
	}

	onFilter(categoryIndex: number | null, programmeIndex: number | null): void {
		// Highlight category filters (pills + dropdown)
		for (let c = 0; c < this.categories.length; c++) {
			const pill = document.querySelector(`.category-filter[data-index="${c}"]`);
			const dropdown = document.querySelector(`.category-dropdown-option[data-index="${c}"]`);

			if (pill) {
				categoryIndex === c ? pill.classList.add('active') : pill.classList.remove('active');
			}
			if (dropdown) {
				categoryIndex === c ? dropdown.classList.add('active') : dropdown.classList.remove('active');
			}
		}

		// Highlight programme filters (pills + dropdown)
		for (let p = 0; p < this.programmes.length; p++) {
			const pill = document.querySelector(`.programme-filter[data-index="${p}"]`);
			const dropdown = document.querySelector(`.programme-dropdown-option[data-index="${p}"]`);

			if (pill) {
				programmeIndex === p ? pill.classList.add('active') : pill.classList.remove('active');
			}
			if (dropdown) {
				programmeIndex === p ? dropdown.classList.add('active') : dropdown.classList.remove('active');
			}
		}

		const currentCategory = categoryIndex === null ? null : this.categories[categoryIndex];
		const currentProgramme = programmeIndex === null ? null : this.programmes[programmeIndex];

		if (this.isMobile) {
			this.updateDropdownButtons(currentCategory, currentProgramme);
		}

		let hasResult = false;

		for (const profile of this.profiles) {
			const category = profile.dataset.category || '';
			const programme = profile.dataset.programme || '';
			let isPresent = true;

			if (category !== currentCategory) isPresent = false;
			if (programme !== currentProgramme) isPresent = false;

			if (isPresent) {
				profile.classList.add('present');
			} else {
				profile.classList.remove('present');
			}

			if (!this.isMobile && isPresent) {
				profile.classList.add('show');
			} else {
				profile.classList.remove('show');
			}

			if (isPresent) {
				hasResult = true;
				if (this.profileScrollbar) {
					this.profileScrollbar.destroy();
					this.profileScrollbar = null;
				}
				this.profileScrollbar = OverlayScrollbars(profile, {
					overflow: {
						x: 'hidden',
						y: 'scroll'
					}
				});
			}
		}

		if (this.isMobile) {
			if (hasResult) {
				this.profilesIcon?.classList.add('active');
			} else {
				this.profilesIcon?.classList.remove('active');
			}
		} else {
			this.profilesIcon?.classList.remove('active');
		}

		if (hasResult) {
			setTimeout(() => {
				const top = this.profilesWrapper?.offsetTop || 0;
				this.scrollToY(top, 'smooth');
			}, 100);
		}
	}

	updateDropdownButtons(currentCategory: string | null, currentProgramme: string | null): void {
		const categoryBtn = document.getElementById('category-dropdown-btn');
		const programmeBtn = document.getElementById('programme-dropdown-btn');
		const categoryList = document.getElementById('category-dropdown-list');
		const programmeList = document.getElementById('programme-dropdown-list');

		if (categoryBtn) {
			categoryBtn.innerHTML = '';
			if (currentCategory) {
				const span = document.createElement('span');
				span.textContent = currentCategory;
				categoryBtn.appendChild(span);
			} else {
				const spanHu = document.createElement('span');
				spanHu.classList.add('hu');
				spanHu.textContent = 'Válassz tematikát!';
				const spanEn = document.createElement('span');
				spanEn.classList.add('en');
				spanEn.textContent = 'Choose a theme';
				categoryBtn.appendChild(spanHu);
				categoryBtn.appendChild(spanEn);
			}
			categoryBtn.setAttribute('aria-expanded', 'false');
		}

		if (programmeBtn) {
			programmeBtn.innerHTML = '';
			if (currentProgramme) {
				const programmeName = currentProgramme.replace(' MA', '');
				const translation = PROGRAMME_TRANSLATIONS[programmeName] || programmeName;

				const spanHu = document.createElement('span');
				spanHu.classList.add('hu');
				spanHu.textContent = translation;

				const spanEn = document.createElement('span');
				spanEn.classList.add('en');
				spanEn.textContent = programmeName;

				programmeBtn.appendChild(spanHu);
				programmeBtn.appendChild(spanEn);
			} else {
				const spanHu = document.createElement('span');
				spanHu.classList.add('hu');
				spanHu.textContent = 'Válassz szakot!';
				const spanEn = document.createElement('span');
				spanEn.classList.add('en');
				spanEn.textContent = 'Choose a programme';
				programmeBtn.appendChild(spanHu);
				programmeBtn.appendChild(spanEn);
			}
			programmeBtn.setAttribute('aria-expanded', 'false');
		}

		categoryList?.classList.remove('active');
		programmeList?.classList.remove('active');
	}

	// setupIcon(): void {
	// 	if (!this.profilesIcon) return;
	// 	this.profilesIcon.onclick = () => {
	// 		console.log('oi');
	// 		document.querySelector('.profile.present')?.classList.add('show');
	// 		this.profilesIcon?.classList.remove('active');
	// 	};
	// }

	setupIcon(): void {
		if (!this.profilesIcon) return;

		if (this.isMobile) {
			this.profilesIcon.onclick = () => {
				const profile = document.querySelector('.profile.present') as HTMLElement | null;
				if (!profile) return;
				profile.classList.toggle('show');

				if (!profile.classList.contains('show')) {
					document.querySelectorAll('.dropdown-list.active').forEach((list) => {
						list.classList.remove('active');
					});
				}
			};
		} else {
			this.profilesIcon.onclick = () => {
				document.querySelector('.profile.present')?.classList.add('show');
				this.profilesIcon?.classList.remove('active');
			};
		}
	}

	makeProfiles(data: Data): void {
		const fragment = new DocumentFragment();
		for (const element of Object.values(data)) {
			const profile = this.getProfile(element);
			this.profiles.push(profile);
			fragment.appendChild(profile);
		}
		this.profilesWrapper?.appendChild(fragment);

		const closeBtns = document.querySelectorAll('.profile-close-btn');
		closeBtns.forEach((btn) => {
			btn.addEventListener('click', () => {
				const profile = btn.closest('.profile') as HTMLElement | null;
				if (!profile) return;
				profile.classList.remove('show');

				if (this.isMobile) {
					document.querySelectorAll('.dropdown-list.active').forEach((list) => {
						list.classList.remove('active');
					});
				} else {
					this.profilesIcon?.classList.add('active');
				}
			});
		});
	}

	getProfile(item: DataItem): HTMLElement {
		const profile = document.createElement('div');
		profile.innerHTML = PROFILE_CLOSE_BTN;
		profile.classList.add('profile');
		profile.dataset.id = item.id.toString();
		profile.dataset.category = item.theme?.toString() || '';
		profile.dataset.programme = item.programme?.toString() || '';
		const title = document.createElement('div');
		title.classList.add('profile-title');
		const titleHu = document.createElement('span');
		titleHu.classList.add('hu');
		titleHu.innerHTML = item.title_hu || 'N/A';
		const titleEn = document.createElement('span');
		titleEn.classList.add('en');
		titleEn.innerHTML = item.title_en || 'N/A';
		title.appendChild(titleHu);
		title.appendChild(titleEn);
		profile.appendChild(title);
		const name = document.createElement('div');
		name.classList.add('profile-name');
		name.innerHTML = item.name || 'N/A';
		profile.appendChild(name);
		if (item.theme || item.programme) {
			const tags = document.createElement('div');
			tags.classList.add('profile-tags');
			if (item.theme) {
				const tag = document.createElement('div');
				tag.classList.add('profile-tag');
				tag.innerHTML = item.theme;
				tags.appendChild(tag);
			}
			if (item.programme) {
				const tag = document.createElement('div');
				tag.classList.add('profile-tag');
				tag.innerHTML = item.programme;
				tags.appendChild(tag);
			}
			profile.appendChild(tags);
		}
		if (item.concept_hu || item.concept_en) {
			const concept = document.createElement('div');
			concept.classList.add('profile-concept');
			const conceptHu = document.createElement('span');
			conceptHu.classList.add('hu');
			conceptHu.innerHTML = item.concept_hu || '';
			const conceptEn = document.createElement('span');
			conceptEn.classList.add('en');
			conceptEn.innerHTML = item.concept_en || '';
			concept.appendChild(conceptHu);
			concept.appendChild(conceptEn);
			profile.appendChild(concept);
		}
		return profile;
	}

	onLangChange(lang: 'hu' | 'en'): void {
		const switcher = document.getElementById('lang-switcher');
		const container = document.getElementById('app');
		if (!switcher || !container) return;
		const prevLang = switcher.dataset.lang || '';
		if (prevLang && prevLang === lang) return;
		container.dataset.lang = lang;
	}

	updateReset(categoryIndex: number | null, programmeIndex: number | null): void {
		if (!this.resetBtn) return;
		if (categoryIndex === null && programmeIndex === null) {
			this.resetBtn.classList.add('hidden');
		} else {
			this.resetBtn.classList.remove('hidden');
		}
	}
}
